// extracted by mini-css-extract-plugin
export default {"Flywordwide_heading":"Flywordwide_Flywordwide_heading__S7V53"};